import QrGiftsList from "@/pages/Special/QrGifts/list.vue";
import QrGiftsForm from "@/pages/Special/QrGifts/EditForm.vue";
import CrmContactsList from "@/pages/Special/CrmContacts/list.vue";
import CrmContactsForm from "@/pages/Special/CrmContacts/EditForm.vue";
import WwwSubscribers from "@/pages/Special/WwwSubscribers/index.vue";
import PresentationContacts from "@/pages/Special/PresentationContacts/index.vue";
import auth from "../middleware/authMiddleware.js";
import canNav from "../middleware/canNavMiddleware.js";

export default [
  {
    path: "/qr-gifts",
    name: "QrGifts",
    component: QrGiftsList,
    meta: {
      middleware: [auth, canNav],
      requirePermission: "QrGifts/view"
    },
    children: [
      {
        path: "view/:id",
        name: "QrGiftsView",
        component: QrGiftsForm,
        props: true,
        meta: {
          middleware: [auth, canNav],
          requirePermission: "QrGifts/view",
          parentName: "QrGifts"
        }
      },
      {
        path: "edit/:id",
        name: "QrGiftsEdit",
        component: QrGiftsForm,
        props: true,
        meta: {
          middleware: [auth, canNav],
          requirePermission: "QrGifts/edit",
          parentName: "QrGifts"
        }
      }
    ]
  },
  {
    path: "/crm-contacts",
    name: "CrmContacts",
    component: CrmContactsList,
    meta: {
      middleware: [auth, canNav],
      requirePermission: "CrmContacts/view"
    },
    children: [
      {
        path: "view/:id",
        name: "CrmContactsView",
        component: CrmContactsForm,
        props: true,
        meta: {
          middleware: [auth, canNav],
          requirePermission: "CrmContacts/view",
          parentName: "CrmContacts"
        }
      },
      {
        path: "edit/:id",
        name: "CrmContactsEdit",
        component: CrmContactsForm,
        props: true,
        meta: {
          middleware: [auth, canNav],
          requirePermission: "CrmContacts/edit",
          parentName: "CrmContacts"
        }
      },
      {
        path: "new",
        name: "CrmContactsAdd",
        component: CrmContactsForm,
        meta: {
          middleware: [auth, canNav],
          requirePermission: "CrmContacts/add",
          parentName: "CrmContacts"
        }
      }
    ]
  },
  {
    path: "/www-subscribers",
    name: "WwwSubscribers",
    component: WwwSubscribers,
    meta: {
      middleware: [auth, canNav],
      requirePermission: "WwwSubscribers/view"
    }
  },
  {
    path: "/presentation-contacts",
    name: "PresentationContacts",
    component: PresentationContacts,
    meta: {
      middleware: [auth, canNav],
      requirePermission: "PresentationContacts/view"
    }
  }
];
